import { fromPairs } from 'lodash';
import { useMemo } from 'react';
import { UserStatus, UserType } from 'api/models';
import {
  FieldType,
  SingleUserField,
  SourceType,
} from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { useUsersQuery } from 'queries/members';

export const useProjectOwnerField = (
  fieldId: number,
): {
  projectOwnerField: SingleUserField;
  isLoading: boolean;
} => {
  const { data: users, isLoading: isUserLoading } = useUsersQuery();
  const nativeUsers = useMemo(
    () =>
      (users ?? []).filter(
        (u) =>
          u.userType === UserType.Native &&
          u.userStatus !== UserStatus.Inactive,
      ),
    [users],
  );
  const fieldLabel = useTranslation('projects.list.project_owner');

  return useMemo(
    () => ({
      projectOwnerField: {
        fieldId,
        fieldName: 'projectOwner',
        fieldLabel,
        type: FieldType.SingleUser,
        private: false,
        userCreated: false,
        metaData: {
          users: {
            by_user_id: fromPairs(nativeUsers.map((x) => [x.userId, x])),
            active_user_ids: nativeUsers.map((x) => x.userId),
            by_project_id: {},
          },
        },
        sourceType: SourceType.Project,
      },
      isLoading: isUserLoading,
    }),
    [fieldId, isUserLoading, fieldLabel, nativeUsers],
  );
};
